import { MakeCall } from './createMakeCall';

/** @swagger /#api-Default-userUserIdPayoutMethodsSetDefaultPut */
export default (makeCall: MakeCall) => (methodId: number) =>
  makeCall('PUT', `/api/v2/user/me/payout-methods/set-default`, {
    data: { defaultMethodId: methodId },
  });
